var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { deleteDrafts, deleteMaps, getMapMomData, getMapPartition, getMapSvg, getMapTheme, getMapVersion, postDrafts, postDraftStatus, updateDrafts, } from "./venues";
import translations from "../translations/resources/en-GB.json";
import { setVenues, setVenuesList, setInitialVenuesList, } from "../store/reducers/venuesSlice";
import IndoorHelper from "../store/helpers/indoorHelper";
import { setVenue } from "../store/reducers/venueSlice";
import { setIsNoMap, setPlaceMapOrderModal, setUploadStatus, } from "../store/reducers/appSlice";
import indoorHelper from "../store/helpers/indoorHelper";
import { draftCreateErrorMsg } from "./helper";
import { MapKeys, MAP_STATUS, DRAFT_TYPE } from "../store/common/constants";
import pako from "pako";
import { generateAttributeCount } from "@here/indoor-map-utilities/attributeCountReport";
/**
 * to create draft for the map where draft is not present
 */
export var createDraft = function (venue, setShowModal, addToast) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, venuesList, venueMap, protocol, env, user, hostname, envName, newVenues, draftBody, response, editImcLink, e_1, newVenues;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                token = getState().user.token;
                venuesList = getState().venues.list;
                venueMap = (_a = getState().venue) === null || _a === void 0 ? void 0 : _a.venue;
                protocol = document.location.protocol;
                env = getState().app.environment;
                user = getState().user.info;
                hostname = document.location.hostname.includes("platform.here.com")
                    ? "platform.here.com"
                    : "platform.in.here.com";
                envName = env.environmentId === "prod" ? "here" : "here-dev";
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                newVenues = venuesList.map(function (v) {
                    if (v.id === venue.id) {
                        return __assign(__assign({}, v), { isDraft: true, draftStatus: MAP_STATUS[MapKeys.CHECKED_OUT].LABEL, buttonText: translations.data["venonboard.internalTools.buttonEditMap"], state: MAP_STATUS[MapKeys.PENDING_UPDATE].LABEL });
                    }
                    return v;
                });
                //this is to refresh the VIEW MAP DETAILS page with correct status, overflow menu
                //when the check-out is clicked
                if (venueMap === null || venueMap === void 0 ? void 0 : venueMap.id) {
                    dispatch(setVenue(__assign(__assign({}, venue), { isDraft: true, draftStatus: MAP_STATUS[MapKeys.CHECKED_OUT].LABEL, state: MAP_STATUS[MapKeys.PENDING_UPDATE].LABEL })));
                }
                dispatch(setVenues(newVenues));
                draftBody = generateDraftPayload(venue);
                setShowModal(true);
                return [4 /*yield*/, updateDrafts(token, draftBody)];
            case 2:
                response = _b.sent();
                if (response.status === 200 || response.status === 202) {
                    setShowModal(false);
                    editImcLink = "".concat(protocol, "//").concat(hostname, "/indoor-map-creator/?cat=") +
                        IndoorHelper.formatDraftHrn(envName, user === null || user === void 0 ? void 0 : user.realm, venue === null || venue === void 0 ? void 0 : venue.id);
                    window.open(editImcLink);
                }
                return [3 /*break*/, 4];
            case 3:
                e_1 = _b.sent();
                //in case of draft creation failure error notification will be displayed
                setShowModal(false);
                newVenues = venuesList.map(function (v) {
                    if (v.id === venue.id) {
                        return __assign(__assign({}, v), { isDraft: false, draftStatus: translations.data["venonboard.internalTools.chipStatusCheckin"], buttonText: translations.data["venonboard.internalTools.buttonEditMap"] });
                    }
                    return v;
                });
                if (venueMap === null || venueMap === void 0 ? void 0 : venueMap.id) {
                    dispatch(setVenue(__assign(__assign({}, venue), { isDraft: false, draftStatus: translations.data["venonboard.internalTools.chipStatusCheckin"] })));
                }
                dispatch(setVenues(newVenues));
                addToast("Draft creation error", draftCreateErrorMsg(e_1 === null || e_1 === void 0 ? void 0 : e_1.response.data), "10", "error", "solid");
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var openInIMC = function (venue, addToast) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        (venue === null || venue === void 0 ? void 0 : venue.draftStatus) ===
            translations.data["venonboard.internalTools.chipStatusCheckin"]
            ? dispatch(viewMapIMC(venue, addToast))
            : dispatch(EditMapIMC(venue));
        return [2 /*return*/];
    });
}); }; };
export var viewMapIMC = function (venue, addToast) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var defaultCollectionHrn, defaultSnapshotData, defaultSnapshotTime, protocol, hostname, imcLink;
    return __generator(this, function (_a) {
        defaultCollectionHrn = getState().overview.defaultHrn;
        defaultSnapshotData = getState().overview.defaultSnapshotData;
        defaultSnapshotTime = getState().overview.defaultSnapshotTime;
        protocol = document.location.protocol;
        hostname = document.location.hostname.includes("platform.here.com")
            ? "platform.here.com"
            : "platform.in.here.com";
        try {
            imcLink = "".concat(protocol, "//").concat(hostname, "/indoor-map-creator/?cat=") +
                defaultCollectionHrn +
                "&layerId=" +
                defaultSnapshotTime +
                "&mapId=" +
                venue.id;
            defaultSnapshotData.snapshotTimes.length === 0
                ? addToast(translations.data["venonboard.internalTools.snapshotNotFound.Title"], translations.data["venonboard.internalTools.snapshotNotFound.Message"], 3, "error", "solid")
                : window.open(imcLink);
        }
        catch (e) {
            addToast(translations.data["venonboard.realmSetup.notificationMessageError"], "", 3, "error", "solid");
        }
        return [2 /*return*/];
    });
}); }; };
export var EditMapIMC = function (venue) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var protocol, env, user, hostname, envName, editImcLink;
    return __generator(this, function (_a) {
        protocol = document.location.protocol;
        env = getState().app.environment;
        user = getState().user.info;
        hostname = document.location.hostname.includes("platform.here.com")
            ? "platform.here.com"
            : "platform.in.here.com";
        envName = env.environmentId === "prod" ? "here" : "here-dev";
        editImcLink = "".concat(protocol, "//").concat(hostname, "/indoor-map-creator/?cat=") +
            IndoorHelper.formatDraftHrn(envName, user === null || user === void 0 ? void 0 : user.realm, venue === null || venue === void 0 ? void 0 : venue.id);
        window.open(editImcLink);
        return [2 /*return*/];
    });
}); }; };
/**
 * Will publish the draft to the collection catalog
 */
export var CheckIn = function (venue, addToast) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, venuesList, env, user, venueMap, envName, newVenues, venueIdx, updatedVenue, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                token = getState().user.token;
                venuesList = getState().venues.list;
                env = getState().app.environment;
                user = getState().user.info;
                venueMap = (_a = getState().venue) === null || _a === void 0 ? void 0 : _a.venue;
                envName = (env === null || env === void 0 ? void 0 : env.environmentId) === "prod" ? "here" : "here-dev";
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, postDraftStatus(token, IndoorHelper.formatDraftHrn(envName, user === null || user === void 0 ? void 0 : user.realm, venue === null || venue === void 0 ? void 0 : venue.id), translations.data["venonboard.internalTools.draftStateCheckedIn"])];
            case 2:
                _b.sent();
                newVenues = venuesList === null || venuesList === void 0 ? void 0 : venuesList.map(function (v) {
                    if ((v === null || v === void 0 ? void 0 : v.id) === (venue === null || venue === void 0 ? void 0 : venue.id)) {
                        return __assign(__assign({}, v), { isDraft: false, draftStatus: MAP_STATUS[MapKeys.CHECKED_IN].LABEL, buttonText: translations.data["venonboard.internalTools.buttonEditMap"], modified: indoorHelper.formattedDate(user.locale, new Date()), state: MAP_STATUS[MapKeys.READY].LABEL });
                    }
                    return v;
                });
                if (venueMap === null || venueMap === void 0 ? void 0 : venueMap.id) {
                    dispatch(setVenue(__assign(__assign({}, venue), { isDraft: false, draftStatus: MAP_STATUS[MapKeys.CHECKED_IN].LABEL, modified: indoorHelper.formattedDate(user.locale, new Date()), state: MAP_STATUS[MapKeys.READY].LABEL })));
                }
                venueIdx = newVenues.findIndex(function (el) { return el.id == venue.id; });
                updatedVenue = newVenues.at(venueIdx);
                newVenues.splice(venueIdx, 1);
                newVenues.unshift(updatedVenue);
                dispatch(setVenues(newVenues));
                addToast(translations.data["venonboard.mapCheckin.notificationTitle"], translations.data["venonboard.mapCheckin.notificationBody"], 3, "positive", "solid");
                return [3 /*break*/, 4];
            case 3:
                error_1 = _b.sent();
                addToast(translations.data["venonboard.mapCheckin.notificationTitle"], translations.data["venonboard.mapCheckin.notificationTitle"] +
                    " failed with error code: " +
                    error_1.response.status, 3, "error", "solid");
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
/**
 * Will delete the draft that has been created but yet not published for the particular map
 */
export var discardCheckout = function (venue, addToast) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, venuesList, env, user, venueMap, envName, newVenues, e_2;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                token = getState().user.token;
                venuesList = getState().venues.list;
                env = getState().app.environment;
                user = getState().user.info;
                venueMap = (_a = getState().venue) === null || _a === void 0 ? void 0 : _a.venue;
                envName = env.environmentId === "prod" ? "here" : "here-dev";
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, deleteDrafts(token, IndoorHelper.formatDraftHrn(envName, user === null || user === void 0 ? void 0 : user.realm, venue === null || venue === void 0 ? void 0 : venue.id))];
            case 2:
                _c.sent();
                newVenues = venuesList.map(function (v) {
                    if (v.id === venue.id) {
                        return __assign(__assign({}, v), { isDraft: false, draftStatus: MAP_STATUS[MapKeys.CHECKED_IN].LABEL, buttonText: translations.data["venonboard.details.cta.imc"], state: MAP_STATUS[MapKeys.READY].LABEL });
                    }
                    return v;
                });
                if (venueMap === null || venueMap === void 0 ? void 0 : venueMap.id) {
                    dispatch(setVenue(__assign(__assign({}, venue), { isDraft: false, draftStatus: MAP_STATUS[MapKeys.CHECKED_IN].LABEL, state: MAP_STATUS[MapKeys.READY].LABEL })));
                }
                dispatch(setVenues(newVenues));
                return [3 /*break*/, 4];
            case 3:
                e_2 = _c.sent();
                console.log("discard checkout", e_2, e_2.response.status);
                addToast(translations.data["venonboard.internalTools.buttonDiscardCheckOut"], translations.data["venonboard.internalTools.buttonDiscardCheckOut"] +
                    " failed with error code: " +
                    ((_b = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _b === void 0 ? void 0 : _b.status), 3, "error", "solid");
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
/**
 * Will delete the particular map and remove it from the display list of maps
 */
export var deleteMap = function (venue, addToast) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, venuesListData, initialVenuesListData, res, newInitialList, newList, e_3;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                token = getState().user.token;
                venuesListData = getState().venues.list;
                initialVenuesListData = getState().venues.initialVenuesList;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, deleteMaps(token, venue.id)];
            case 2:
                res = _b.sent();
                if (res) {
                    newInitialList = initialVenuesListData.filter(function (item) { return item.id !== venue.id; });
                    newList = venuesListData.filter(function (item) { return item.id !== venue.id; });
                    //the map needs to be deleted from both initialvenue list and the list
                    dispatch(setInitialVenuesList(newInitialList));
                    dispatch(setVenuesList(newList));
                    dispatch(setVenues(newList));
                    if (!newList.length) {
                        dispatch(setIsNoMap(true));
                    }
                    addToast(translations.data["venonboard.internalTools.deleteMapCompletion.title"], translations.data["venonboard.internalTools.deleteMapCompletion.body"], 3, "positive", "solid");
                }
                return [3 /*break*/, 4];
            case 3:
                e_3 = _b.sent();
                addToast("Draft creation error", ((_a = e_3 === null || e_3 === void 0 ? void 0 : e_3.response) === null || _a === void 0 ? void 0 : _a.status) === 409
                    ? translations.data["venonboard.internalTools.CreateDraft409Error"]
                    : translations.data["venonboard.internalTools.CreateDraftMessageError"], 3, "error", "solid");
                console.log(e_3);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var mapOrderDraft = function (mapObj, history) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, res, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getState().user.token;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dispatch(setPlaceMapOrderModal(true));
                return [4 /*yield*/, postDrafts(token, mapObj)];
            case 2:
                res = _a.sent();
                if (res.status === 200 || res.status === 202) {
                    dispatch(setPlaceMapOrderModal(false));
                    dispatch(setUploadStatus("finished"));
                    history.push({
                        pathname: "/upload",
                        search: window.location.search,
                    });
                }
                return [3 /*break*/, 4];
            case 3:
                e_4 = _a.sent();
                dispatch(setPlaceMapOrderModal(false));
                dispatch(setUploadStatus("failure"));
                history.push({
                    pathname: "/upload",
                    search: window.location.search,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var open3DViewer = function (venue) {
    var BaseUrl = "".concat(window.location.origin, "/indoor-panorama-viewer");
    // before creating url for panorama it checks whether selected map is legacy or UUID based map.
    var mapId = indoorHelper.validateIsMicelloId(venue.id)
        ? indoorHelper.getMapId(venue.id)
        : venue.id;
    var panoramaViewer = "".concat(BaseUrl, "/?mapId=").concat(mapId);
    window.open(panoramaViewer);
};
/**
 * This is to generate a payload for createDraft method
 * @param venue, selected venue.
 * @returns <IDraftRequestPayloadType> eg: (updateDraft endpoint payload request payload)
 */
var generateDraftPayload = function (venue) {
    var id = venue.id, address = venue.address, mapName = venue.name, location = venue.location, mapDetails = venue.mapDetails, venueCategory = venue.venueCategory, description = venue.description;
    var requestBuilder = {
        orderData: {
            mapName: mapName,
            notes: description,
            isPrivate: true,
        },
        draftType: DRAFT_TYPE.UPDATE_DRAFT_ORDER,
        indoorMapId: id,
        location: location,
        address: address,
        mapDetails: mapDetails,
        venueCategory: venueCategory,
    };
    return requestBuilder;
};
/**
 * Will return Attribute QA report for the given map
 * Attribute QA report will de downloaded in csv format
 */
export var attributeCountReport = function (venue, setShowAttrReportModal, addToast) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var token, indoorCatalogHrn, defaultCollectionHrn, version, partitions, id_1, venueIdIncludedPartition, mom, svg, rule, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setShowAttrReportModal(true);
                token = getState().user.token;
                indoorCatalogHrn = getState().app.indoorCatalogHrn;
                defaultCollectionHrn = getState().overview.defaultHrn;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, getMapVersion(token, indoorCatalogHrn)];
            case 2:
                version = (_a.sent()).data.version;
                return [4 /*yield*/, getMapPartition(token, indoorCatalogHrn, version)];
            case 3:
                partitions = (_a.sent()).data.partitions;
                id_1 = !venue.id.includes("indoor")
                    ? "indoormap-00000000-0000-4000-a000-".concat(venue.id.padStart(12, "0"))
                    : venue.id;
                venueIdIncludedPartition = partitions.find(function (p) { return p.partition == venue.id || p.partition == id_1; });
                if (venueIdIncludedPartition === null || venueIdIncludedPartition === void 0 ? void 0 : venueIdIncludedPartition.layer) {
                    mom = getMapMomData(token, indoorCatalogHrn, venueIdIncludedPartition === null || venueIdIncludedPartition === void 0 ? void 0 : venueIdIncludedPartition.layer, venueIdIncludedPartition === null || venueIdIncludedPartition === void 0 ? void 0 : venueIdIncludedPartition.dataHandle);
                    svg = getMapSvg(token, defaultCollectionHrn);
                    rule = getMapTheme(token, defaultCollectionHrn);
                    return [2 /*return*/, Promise.all([mom, svg, rule])
                            .then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                            var data, str, mapData, report, blob, url, link;
                            var _a;
                            return __generator(this, function (_b) {
                                data = pako.inflate((_a = res[0]) === null || _a === void 0 ? void 0 : _a.data);
                                str = new TextDecoder().decode(data);
                                mapData = JSON.parse(str);
                                report = generateAttributeCount(mapData);
                                blob = new Blob([report.toString()], {
                                    type: "text/csv;charset=utf-8",
                                });
                                url = URL.createObjectURL(blob);
                                link = document.createElement("a");
                                link.download = "".concat(id_1, "_QAR");
                                link.href = url;
                                link.click();
                                setShowAttrReportModal(false);
                                return [2 /*return*/];
                            });
                        }); })
                            .catch(function (e) {
                            setShowAttrReportModal(false);
                            addToast("Attribute QA Report", "failed to generate report - ".concat(e), "10", "error", "solid");
                        })];
                }
                else {
                    setShowAttrReportModal(false);
                    addToast("Attribute QA Report", translations.data["venonboard.attributeQAReport.noMapData"], "10", "error", "solid");
                }
                return [3 /*break*/, 5];
            case 4:
                e_5 = _a.sent();
                console.log("e", e_5);
                setShowAttrReportModal(false);
                addToast("Attribute QA Report", "failed to generate report - ".concat(e_5), "10", "error", "solid");
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
